import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { ReadonlyEmailField } from "@/features/user-setting/components/change-email/ReadonlyEmailField";
import { TChangeEmailForm } from "@/features/user-setting/types/changeEmailForm";
import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type TEmailChangeFieldsProps = {
  control: Control<TChangeEmailForm>;
  currentEmail?: string | null;
};

export const EmailChangeFields: FC<TEmailChangeFieldsProps> = ({ control, currentEmail }) => {
  return (
    <InnerBox padding="24px">
      <Stack gap="16px">
        <ReadonlyEmailField label="現在のメールアドレス" email={currentEmail} required />
        <Box width="320px" maxWidth="100%">
          <FormField control={control} name="newEmail" label="新しいメールアドレス" required>
            <Input placeholder="入力してください" />
          </FormField>
        </Box>
      </Stack>
    </InnerBox>
  );
};
